import { jsx } from '@emotion/react';
import { Styles } from './TableTd.es.js';

const TableTh = ({ children, className, freeze, headers, id, scope, shadowed, role = "columnheader" }) => {
  return jsx("th", { css: [Styles.root, className], "data-freeze": freeze, "data-shadowed": shadowed, "data-zds": true, headers, id, role, scope }, children);
};

export { TableTh };
//# sourceMappingURL=TableTh.es.js.map
